import { formatKopecks } from '@krp/ui-kit'

export { formatKopecks }

/**
 * Показ значений журналов. Деньги — одна утилита ui-kit;
 * время — по часам браузера (как и отбор по датам).
 */

/**
 * Момент из ответа показывается по часам браузера — теми же, по которым
 * считается отбор «с/по дату». Сервер отдаёт моменты с нулевым смещением, поэтому
 * показ «как в строке» выдал бы UTC за время магазина. `timeZone` — для тестов.
 */
export function formatInstant(value: string | null, empty = 'нет даты', timeZone?: string): string {
  if (value === null) return empty
  const time = Date.parse(value)
  if (Number.isNaN(time)) return value
  return new Intl.DateTimeFormat('ru-RU', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23',
    ...(timeZone !== undefined ? { timeZone } : {}),
  })
    .format(time)
    .replace(',', '')
}

/** Количество с точностью до 3 знаков, без хвостовых нулей: 1.250 → «1,25». */
export function formatQuantity(value: number): string {
  return new Intl.NumberFormat('ru-RU', { maximumFractionDigits: 3 }).format(value)
}
